import React from 'react';
import styles from './Tag.module.scss';

interface Props {
  tag: string;
  children?: React.ReactNode;
}

const Tag = (props: Props) => {
  const { tag, children } = props;

  return (
    <span className={styles.span}>
      {tag}{children}
    </span>
  );
};

export default Tag;
